import React, { useState, useEffect } from 'react';
import { Form, Row, Col, Modal, Button } from "react-bootstrap"
import { Page, SearchBar } from 'components';
import { Results } from './components';
import { useHistory } from 'react-router-dom';

import Header from '../../components/Header/Header';
import Reload from '../../components/Reload/Reload';
import ApiGServer from 'services/ApiGServer';
import ApiMServer from 'services/ApiMServer';
import { useAppTheme } from '../../contexts/ThemeContext';


const Equipments = (props) => {
  const history = useHistory();

  const user = JSON.parse(localStorage.getItem('userData'));
  if (user?.permission?.equipments?.read !== true) {
    window.location.replace('/home');
  }

  const [equipments, setEquipments] = useState([]);
  const [equipmentsToShow, setEquipmentsToshow] = useState([]);
  const [open, setOpen] = React.useState(false);
  const [searchData, setSearchData] = useState('');
  const [equipmentId, setEquipmentId] = useState('');
  const [loading, setLoading] = useState(true);
  const [checkOwner, setCheckOwner] = useState(false);
  const [checkLocation, setCheckLocation] = useState(false);

  const [stateWifi, setStateWifi] = useState(0);
  const [statePh, setStatePh] = useState(0);

  const STORAGE_KEY = 'filters:equipments';

  const currentTheme = useAppTheme();

  // Load persisted filters on mount
  useEffect(() => {
    const persisted = JSON.parse(localStorage.getItem(STORAGE_KEY) || 'null');
    if (persisted) {
      if (typeof persisted.searchData === 'string') setSearchData(persisted.searchData);
      if (typeof persisted.checkOwner === 'boolean') setCheckOwner(persisted.checkOwner);
      if (typeof persisted.checkLocation === 'boolean') setCheckLocation(persisted.checkLocation);
      if (typeof persisted.stateWifi === 'number') setStateWifi(persisted.stateWifi);
      if (typeof persisted.statePh === 'number') setStatePh(persisted.statePh);
    }
  }, []);

  // Persist filters when they change
  useEffect(() => {
    localStorage.setItem(
      STORAGE_KEY,
      JSON.stringify({ searchData, checkOwner, checkLocation, stateWifi, statePh })
    );
  }, [searchData, checkOwner, checkLocation, stateWifi, statePh]);

  const handleStatateWifi = () => {
    setStateWifi(stateWifi === 0 ? 1 : stateWifi === 1 ? 2 : 0)
    handleSearch(checkOwner, checkLocation, stateWifi === 0 ? 1 : stateWifi === 1 ? 2 : 0, statePh);
  };

  const handleStatatePh = () => {
    setStatePh(statePh === 0 ? 1 : statePh === 1 ? 2 : 0)
    handleSearch(checkOwner, checkLocation, stateWifi, statePh === 0 ? 1 : statePh === 1 ? 2 : 0);
  };

  const handleClickOpen = (id) => {
    setEquipmentId(id);
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  const handleChangeProprietari = () => {
    if (checkOwner === false) {
      setCheckLocation(false);
    }
    setCheckOwner(!checkOwner);
    handleSearch(!checkOwner, false, stateWifi, statePh);
  }

  const handleChangeLocate = () => {
    if (checkLocation === false) {
      setCheckOwner(false);
    }
    setCheckLocation(!checkLocation);
    handleSearch(false, !checkLocation, stateWifi, statePh);
  }

  const getEquipments = async () => {
    setLoading(true);
    try {
      const { data } = await ApiGServer.get(`/equipment/all`);
      const sortedData = data.sort((a, b) => a.serialnumber.localeCompare(b.serialnumber));
      setEquipments(sortedData);
      setEquipmentsToshow(sortedData);
    } catch (error) {
      console.log(error);
    }
    setLoading(false);
  };

  const removeEquipment = async () => {
    try {
      setOpen(false);
      await ApiMServer.post('/equipment/delete', { "_id": equipmentId });
      getEquipments();
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    getEquipments();
  }, [])

  const handleSearch = (f0, f1, f2, f3) => {
    if (f0 == null) {
      f0 = checkOwner;
    }
    if (f1 == null) {
      f1 = checkLocation;
    }
    if (f2 == null) {
      f2 = stateWifi;
    }
    if (f3 == null) {
      f3 = statePh;
    }

    if (searchData === '' && f0 === false && f1 === false && f2 === 0 && f3 === 0) {
      setEquipmentsToshow(equipments);
    } else {

      var equipmentsSearch = [...equipments];

      if (searchData !== '') {
        equipmentsSearch = equipmentsSearch.filter(item =>
          item?.serialnumber?.toLowerCase().includes(searchData.toLowerCase()) ||
          item?.versaosw?.toLowerCase().includes(searchData.toLowerCase())
        );
      }

      if (f0) {
        equipmentsSearch = equipmentsSearch.filter(item =>
          item.mode === "OWNER"
        );
      }

      if (f1) {
        equipmentsSearch = equipmentsSearch.filter(item =>
          item.mode === 'RENTAL'
        );
      }

      if (f2 === 1) {
        equipmentsSearch = equipmentsSearch.filter(v => v.wf === "OK")
      } else if (f2 === 2) {
        equipmentsSearch = equipmentsSearch.filter(v => v.wf !== "OK")
      }

      if (f3 === 1) {
        equipmentsSearch = equipmentsSearch.filter(v => v.calph === "OK")
      } else if (f3 === 2) {
        equipmentsSearch = equipmentsSearch.filter(v => v.calph !== "OK")
      }

      setEquipmentsToshow(equipmentsSearch);
    }
  };

  const handleSearchData = (e) => {
    setSearchData(e.target.value);
  };

  // Auto-apply filters on changes and after data loads
  useEffect(() => {
    handleSearch(checkOwner, checkLocation, stateWifi, statePh);
  }, [equipments, searchData, checkOwner, checkLocation, stateWifi, statePh]);

  const handleClick = () => {
    history.push('/equipments/add');
  };

  const handleClickTelemetria = () => {
    history.push('/equipments/telemetria');
  };

  return (
    <Page className="p-3" title="Equipamentos">
      <Header page={'Equipamentos'} />

      {loading && <Reload />}


      <Row className="align-items-center g-2">
        <Col xs={8} sm={6} md={6} lg={6} xl={6} xxl={6}>

          <SearchBar
            onSearch={() => handleSearch(checkOwner, checkLocation, stateWifi, statePh)}
            onSearchData={handleSearchData}
            searchData={searchData}
          />

        </Col>
        <Col xs={4} sm={6} md={6} lg={6} xl={6} xxl={6} className="text-md-end text-center">
          <Button
          className='me-2'
            disabled={!user?.permission?.equipments?.read}
            onClick={handleClickTelemetria}
            variant="outline-success"
          >
            Telemetria
          </Button>
          <Button
            disabled={!user?.permission?.equipments?.write}
            onClick={handleClick}
            variant="success"
          >
            Adicionar Equipamento
          </Button>
        </Col>
      </Row>

      <Row className="align-items-center mt-3 mb-2">
        <Col xs="auto">
          <Form.Check type="checkbox" inline>
            <Form.Check.Input
              type="checkbox"
              onChange={handleChangeProprietari}
              isValid
              checked={checkOwner}
            />
            <Form.Check.Label>Proprietário</Form.Check.Label>
          </Form.Check>
        </Col>

        <Col xs="auto">
          <Form.Check type="checkbox" inline>
            <Form.Check.Input
              type="checkbox"
              onChange={handleChangeLocate}
              isValid
              checked={checkLocation}
            />
            <Form.Check.Label>Locação</Form.Check.Label>
          </Form.Check>
        </Col>

        <Col xs="auto">
          <Form.Check type="checkbox" inline>
            <Form.Check.Input
              type="checkbox"
              onChange={handleStatateWifi}
              isValid
              checked={stateWifi === 1 ? true : stateWifi === 2 ? false : undefined}
            />
            <Form.Check.Label>Wi-Fi</Form.Check.Label>
          </Form.Check>
        </Col>

        <Col xs="auto">
          <Form.Check type="checkbox" inline>
            <Form.Check.Input
              type="checkbox"
              onChange={handleStatatePh}
              isValid
              checked={statePh === 1 ? true : statePh === 2 ? false : undefined}
            />
            <Form.Check.Label>PH Calibrado</Form.Check.Label>
          </Form.Check>
        </Col>
      </Row>

      {equipments && (
        <Results
          user={user}
          data={equipmentsToShow}
          currentTheme={currentTheme}
          onRemoveButton={handleClickOpen}
        />
      )}

      <Modal
        show={open}
        onHide={handleClose}
        contentClassName={currentTheme === 'dark' ? 'bg-dark text-light' : 'bg-light text-dark'}
      >
        <Modal.Header
          closeButton
          className={currentTheme === 'dark' ? 'bg-dark text-light border-secondary' : 'bg-light text-dark'}
        >
          <Modal.Title id="alert-dialog-title">Remover</Modal.Title>
        </Modal.Header>
        <Modal.Body className={currentTheme === 'dark' ? 'bg-dark text-light' : 'bg-light text-dark'}>
          Confirma Remover este Equipamento?
        </Modal.Body>
        <Modal.Footer className={currentTheme === 'dark' ? 'bg-dark text-light border-secondary' : 'bg-light text-dark'}>
          <Button variant="secondary" onClick={handleClose}>
            Não
          </Button>
          <Button variant="danger" onClick={removeEquipment}>
            Sim
          </Button>
        </Modal.Footer>
      </Modal>

    </Page >
  );
};

export default Equipments;
